import { CommonModule } from '@angular/common';
import { Component, EventEmitter, OnInit, Output, Injector, ChangeDetectionStrategy } from '@angular/core';
import { Sysai85Component } from './sysai85.component';
//import { Sysai85DetailComponent } from './sysai85-detailPkg.component';
import { JackBaseComponentModule,MaterialModule } from 'jk-service';
import { JkBillFormComponent } from 'jk-advcom';

@Component({
  selector: 'app-sysai85-bill',
  standalone: true,
  imports: [CommonModule,
    MaterialModule,
    JackBaseComponentModule,
    Sysai85Component,
    //Sysai85DetailComponent,
    ],
  templateUrl: './sysai85BillPkg.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: [],
})
export class Sysai85BillComponent extends JkBillFormComponent implements OnInit {
  override _programId = ' sysai85'; //###
  override masterPage!:  Sysai85Component;
  //override detailPage!:  Sysai85DetailComponent;
  constructor() {
    super();
    this.setFormOpt2(); //###
  }

  override ngOnInit() {
    super.ngOnInit();
  }
  override async ngAfterViewInit() {
    super.ngAfterViewInit();
  }
  override doMasterPageReady($event: any) {
    super.doMasterPageReady($event);
  }
  // 以下客製 --------------------------------------------------------


}
